<template>
  <div>
    <b-modal
        :title="title"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="xl"
        no-close-on-backdrop lazy>
      <div class="row">
        <div class="col-md-6 col-lg-3">
          <b-form-group>
            <b-input-group class="input-group-trans">
              <b-form-input v-model="formSearchData.keyword" :placeholder="$t('Keyword')"/>
              <b-input-group-append>
                <b-input-group-text>
                  <img src="images/ico-search.png"/>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-md-6 col-lg-3">
          <b-form-group>
            <b-button @click="search" pill size="lg" class="btn-block btn-trans-primary">{{
                $t("Search now")
              }}
            </b-button>
          </b-form-group>
        </div>
      </div>
      <div class="mb-2">
        <button class="btn-trans-small mr-1 mb1" @click="selectAll"><img src="images/ico-plus-circle-solid-16.png"/>
          {{ $t("Select all") }}
        </button>
        <button class="btn-trans-small mr-1 mb1" @click="save"><img src="images/ico-save-solid-16.png"/>
          {{ $t("Save") }}
        </button>
      </div>
      <vue-custom-scrollbar class="list-participants row">
        <div class="col-md-12 col-lg-6 col-xl-4" v-for="(participant, index) in participants" :key="index">
          <b-card class="participant-item" @click="participant.IsSelected = !participant.IsSelected">
            <div class="d-flex">
              <div class="participant-avatar">
                <div class="avatar">
                  <b-icon :icon="participant.IsSelected ? 'check2' : 'person-fill'"></b-icon>
                </div>
              </div>
              <div class="participant-info">
                <div class="id d-flex justify-content-between">
                  <div>{{ participant.Fullname }}</div>
                  <strong class="trans-id">ID: {{ participant.TransID }}</strong></div>
                <div class="email">
                  <b-icon icon="envelope-fill"></b-icon>
                  <a :href="'mailto:' + participant.Email">{{ participant.Email }}</a></div>
                <div class="phone">
                  <b-icon icon="telephone-fill"></b-icon>
                  <a :href="'tel:' + participant.PhoneNumber">{{ participant.PhoneNumber }}</a></div>
              </div>
            </div>
          </b-card>
        </div>
      </vue-custom-scrollbar>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "AddParticipantsModal",
  data: function () {
    return {
      loading: false,
      show: false,
      title: "",
      searchData: {
        id: null,
        keyword: ""
      },
      formSearchData: {
        id: null,
        keyword: ""
      },
      schedules: [],
      participants: []
    }
  },
  created() {
    this.title = this.$t("Participant picker");
  },
  methods: {
    async open(idSchedule) {
      this.show = true;

      this.formSearchData = {
        id: idSchedule,
        keyword: ""
      };

      this.search()
    },
    search() {
      this.formData = this.formSearchData;
      this.load();
    },
    async load() {
      this.loading = true;
      let response = await meetingService.initAddParticipantsToSchedule(this.formData);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let participants = JSON.parse(response.substr(3));
      participants.forEach(x => {
        x.IsSelected = false;
      })

      this.participants = participants;
    },
    selectAll() {
      if (this.participants.find(x => x.IsSelected === false))
        this.participants.forEach(x => x.IsSelected = true);
      else
        this.participants.forEach(x => x.IsSelected = false);
    },
    async save() {
      let ids = this.participants.filter(x => x.IsSelected).map(x => x.ParticipantID);
      if (ids.length === 0) {
        dialogHelper.alert("Please select participant (s) to add to schedule!", "warning");
        return;
      }

      let result = await dialogHelper.confirm("Are you sure to add to schedule this participant (s)?")
      if (!result)
        return;

      this.loading = true;
      let response = await meetingService.addParticipantToSchedule({
        idsParticipant: JSON.stringify(ids),
        idSchedule: this.formData.id
      });

      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      this.show = false;
      this.$emit("added");
    }
  }
}
</script>

<style scoped>

</style>